﻿import { CheckCircle2, Clock } from "lucide-react";
import type { StatusTab } from "@/hooks/quotes/useQuotesData";;

export function QuotesFilters({
  statusTab,
  setStatusTab,
  setCurrentPage,
  allCount,
  pendingCount,
  inProgressCount,
  completedCount,
}: {
  statusTab: StatusTab;
  setStatusTab: (tab: StatusTab) => void;
  setCurrentPage: (page: number) => void;
  allCount: number;
  pendingCount: number;
  inProgressCount: number;
  completedCount: number;
}) {
  return (
    <div className="flex items-center gap-2 mb-6 overflow-x-auto pb-1 hide-scrollbar">
      <button
        onClick={() => {
          setStatusTab("ALL");
          setCurrentPage(1);
        }}
        className={`flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors shrink-0 ${
          statusTab === "ALL"
            ? "bg-blue-600 text-white"
            : "bg-slate-900 border border-slate-800 text-slate-300 hover:bg-slate-800"
        }`}
      >
        <span>Todos</span>
        <span className="px-1.5 py-0.5 rounded-full text-xs bg-slate-800 text-slate-300">
          {allCount}
        </span>
      </button>

      <button
        onClick={() => {
          setStatusTab("PENDING");
          setCurrentPage(1);
        }}
        className={`flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors shrink-0 ${
          statusTab === "PENDING"
            ? "bg-amber-600 text-white"
            : "bg-slate-900 border border-slate-800 text-slate-300 hover:bg-slate-800"
        }`}
      >
        <Clock size={14} className="text-amber-400" />
        <span>Pendentes</span>
        <span className="px-1.5 py-0.5 rounded-full text-xs bg-amber-500/20 text-amber-300">
          {pendingCount}
        </span>
      </button>

      <button
        onClick={() => {
          setStatusTab("IN_PROGRESS");
          setCurrentPage(1);
        }}
        className={`flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors shrink-0 ${
          statusTab === "IN_PROGRESS"
            ? "bg-blue-600 text-white"
            : "bg-slate-900 border border-slate-800 text-slate-300 hover:bg-slate-800"
        }`}
      >
        <CheckCircle2 size={14} className="text-blue-400" />
        <span>Aprovados / No Pátio</span>
        <span className="px-1.5 py-0.5 rounded-full text-xs bg-blue-500/20 text-blue-300">
          {inProgressCount}
        </span>
      </button>

      <button
        onClick={() => {
          setStatusTab("COMPLETED");
          setCurrentPage(1);
        }}
        className={`flex items-center gap-2 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors shrink-0 ${
          statusTab === "COMPLETED"
            ? "bg-emerald-600 text-white"
            : "bg-slate-900 border border-slate-800 text-slate-300 hover:bg-slate-800"
        }`}
      >
        <CheckCircle2 size={14} className="text-emerald-400" />
        <span>Histórico (Concluídos)</span>
        <span className="px-1.5 py-0.5 rounded-full text-xs bg-emerald-500/20 text-emerald-300">
          {completedCount}
        </span>
      </button>
    </div>
  );
}
